/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DowntimeReason } from '../../models/downtime-reason';

export interface GetReasonsFlatList$Params {
  workCenterId: number;
}

export function getReasonsFlatList(http: HttpClient, rootUrl: string, params: GetReasonsFlatList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DowntimeReason>>> {
  const rb = new RequestBuilder(rootUrl, getReasonsFlatList.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DowntimeReason>>;
    })
  );
}

getReasonsFlatList.PATH = '/api/v1/Downtimes/ReasonsFlatList/{workCenterId}';
